<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToSlide'
});
</script>
<template>
	<div ref="slide" :flex="flex ? flex : null" class="to-slide" :class="setClass" @mouseover="pause" @mouseout="play" @touchstart="touchstart" @touchend="touchend" @touchmove="touchmove">
		<div class="to-slide-pic">
			<ul ref="ul" class="to-slide-wrapper" :style="setUlStyle">
				<li ref="firstFake" class="to-slide-item"></li>
				<slot></slot>
				<li ref="lastFake" class="to-slide-item"></li>
			</ul>
		</div>
		<div v-if="length > 1" class="to-slide-fn">
			<to-icon value="back" link class="to-slide-fn-item type-prev" @click="prev()"></to-icon>
			<to-icon value="next" link class="to-slide-fn-item type-next" @click="next()"></to-icon>
		</div>
		<div v-if="length > 1" class="to-slide-page">
			<span v-for="index of length" :key="index" class="to-slide-page-item" :class="{ 'is-on': index === current + 1 }" @click="to(index - 1)"></span>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { CSSProperties, computed, onMounted, ref, nextTick } from 'vue'



interface Props {
	mode?: string
	autoplay?: boolean
	speed?: number | string
	pagerPosition?: string
	flex?: boolean
}
const props = withDefaults(defineProps<Props>(), {
	mode: 'default',
	autoplay: false,
	speed: 2000,
	pagerPosition: '',
	flex: false
})

const length = ref(0)
const current = ref(0)
const dis = ref(0)
const animate = ref(true)
const width = ref(0)
const playTimer = ref(null)
const startPosition = ref(0)
const slide = ref(null)
const ul = ref(null)
const lastFake = ref(null)
const firstFake = ref(null)
const ulPosition = computed(() => {
	return (current.value + 1) * width.value * -1
})
const setUlStyle = computed(() => {
	let obj: CSSProperties = {}
	obj.transform = `translateX(${ulPosition.value + dis.value}px)`
	if (animate.value) {
		obj.transition = 'transform 0.3s ease-out'
	}
	obj.width = `${(length.value + 2) * 100}%`
	return obj
})

const setClass = computed(() => {
	let arr: string[] = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	if (props.pagerPosition === 'outer') {
		arr.push(`is-outer`)
	}
	return arr
})

onMounted(() => {
	nextTick(() => {
		width.value = slide.value.offsetWidth
		setLength()
		lastFake.value.innerHTML = ul.value.querySelector(':nth-child(2)').innerHTML
		firstFake.value.innerHTML = ul.value.querySelector(`:nth-child(${length.value + 1})`).innerHTML
		play()
		window.addEventListener('resize', () => {
			adjust()
		})
	})
})

function play() {
	if (!props.autoplay || length.value < 2) {
		return
	}
	playTimer.value = setInterval(() => {
		next()
	}, Number(props.speed))
}
function pause() {
	clearInterval(playTimer.value)
}
function setLength() {
	length.value = ul.value.children.length - 2
}
function next() {
	if (animate.value) {
		current.value += 1
		if (current.value === length.value) {
			setTimeout(() => {
				animate.value = false
				current.value = 0
				setTimeout(() => {
					animate.value = true
				}, 300)
			}, 300)
		}
	}
}
function prev() {
	if (animate.value) {
		current.value -= 1
		if (current.value === -1) {
			setTimeout(() => {
				animate.value = false
				current.value = length.value - 1
				setTimeout(() => {
					animate.value = true
				}, 300)
			}, 300)
		}
	}
}
function touchstart(e) {
	if (length.value < 2) {
		return
	}
	startPosition.value = e.touches[0].clientX
	animate.value = false
}
function touchend() {
	if (length.value < 2) {
		return
	}
	animate.value = true
	if (dis.value > 10) {
		prev()
		dis.value = 0
	} else if (dis.value < -10) {
		next()
		dis.value = 0
	}
}
function touchmove(e) {
	if (length.value < 2) {
		return
	}
	dis.value = e.touches[0].clientX - startPosition.value
}
function adjust() {
	width.value = slide.value.offsetWidth
}
function reset() {
	current.value = 0
}
function to(i: number) {
	current.value = i
}

defineExpose({
	reset,
	adjust,
	prev,
	next
})
</script>
